import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Generator from './pages/Generator';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Generator />} />
      </Routes>
    </Router>
  );
}

export default App;
